/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetMarketsByGroupIDForMarketScreen,
    GetMarketByMarketIDFromMarketScreen,
    SaveMarketDetails,
    UpdateMarketDetails,
    GetAllGroupsForMarketScreen,
    GetAllFactoriesByGroupID
};

async function GetAllGroupsForMarketScreen() {
    const response = await CommonGet('/api/MarketScreen/GetAllGroupsForMarketScreen', null);
    return response.data;
}

async function GetMarketsByGroupIDForMarketScreen(groupID) {
    const response = await CommonGet('/api/MarketScreen/GetNewMarketsByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetMarketByMarketIDFromMarketScreen(marketID) {
    const response = await CommonGet('/api/MarketScreen/GetMarketByMarketID', 'marketID=' + parseInt(marketID));
    return response.data;
}
async function SaveMarketDetails(model) {
    const response = await CommonPost('/api/MarketScreen/SaveMarketDetails', null, model);
    return response;
}

async function UpdateMarketDetails(values) {
    const response = await CommonPost('/api/MarketScreen/UpdateMarketDetails', null, values);
    return response;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/MarketScreen/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}
